var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptylike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 192,
    viewBox: "0 0 224 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.62 188.791L114.613 188.794L114.606 188.798C113.805 189.229 112.909 189.455 112 189.455C111.091 189.455 110.195 189.229 109.394 188.798L109.387 188.794L109.38 188.791C107.254 187.665 80.3898 173.02 54.0946 149.992C27.6678 126.848 2.50067 95.831 2.5 62.0013C2.51817 46.2262 8.79287 31.1024 19.9476 19.9476C31.1024 8.79287 46.2262 2.51817 62.0013 2.5C81.9202 2.50038 99.2358 11.0536 110.001 25.3911L112 28.0537L113.999 25.3911C124.764 11.0536 142.08 2.50039 161.999 2.5C177.774 2.51817 192.898 8.79287 204.052 19.9476C215.207 31.1027 221.482 46.2271 221.5 62.0028C221.499 95.8319 196.332 126.849 169.905 149.992C143.61 173.02 116.746 187.665 114.62 188.791Z",
    stroke: "black",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptylike);
export default __webpack_public_path__ + "static/media/empty like.72319badb178ea1e36b6b8547706702f.svg";
export { ForwardRef as ReactComponent };